<div *ngIf="!hideToolbars()" class="hamburger-menu">
     <div *ngIf="isBackEnabled" @fadeAnimationQuick>
        <button *ngIf="!isCustomBackEnabled" mat-icon-button (click)="goBack()">
            <mat-icon>{{ isCloseButton ? 'clear' : 'arrow_back' }}</mat-icon>
        </button>
        <button *ngIf="isCustomBackEnabled" mat-icon-button (click)="customBackButton.method()">
            <mat-icon>{{ customBackButton.icon() }}</mat-icon>
        </button>
    </div>
    <button *ngIf="!isBackEnabled && !isDesktop()" mat-icon-button (click)="toggleOpen()">
        <mat-icon>menu</mat-icon>
    </button>
</div>
